export const LOCALE_PREFIX =
    'scenes.Gnosus.components.EntityStack.components.StackContent.components.SearchContent.components.SearchResults'

export const VIRTUAL_LIST_ID = 'searchResult_virtual_list'
